export const parseCurrency = (value) => {
    if (typeof value !== 'string') {
        return value;
    }
    // Remove currency symbol and non-numeric characters
    const numericValue = parseFloat(value.replace(/[^\d.-]/g, ''));
    return isNaN(numericValue) ? '' : numericValue;
}
